/**
 * Custom Sort Dropdown Component
 * A custom dropdown for sorting that shows only the selected option + arrow
 */

class CustomSortDropdown extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.custom-sort-dropdown__trigger');
    this.dropdown = this.querySelector('.custom-sort-dropdown__options');
    this.hiddenInput = this.querySelector('input[name="sort_by"]');
    this.options = this.querySelectorAll('.custom-sort-dropdown__option');
    
    this.init();
  }

  init() {
    // Toggle dropdown on trigger click
    this.trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggleDropdown();
    });

    // Handle option selection
    this.options.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        this.selectOption(option);
      });

      // Keyboard support
      option.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.selectOption(option);
        }
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.closeDropdown();
      }
    });

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.closeDropdown();
        this.trigger.focus();
      }
    });
  }

  toggleDropdown() {
    if (this.isOpen()) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  openDropdown() {
    this.trigger.setAttribute('aria-expanded', 'true');
    this.dropdown.classList.add('active');
    this.classList.add('is-open');
  }

  closeDropdown() {
    this.trigger.setAttribute('aria-expanded', 'false');
    this.dropdown.classList.remove('active');
    this.classList.remove('is-open');
  }

  isOpen() {
    return this.trigger.getAttribute('aria-expanded') === 'true';
  }

  selectOption(option) {
    const value = option.getAttribute('data-value');
    const label = option.getAttribute('data-label');

    // Update hidden input
    this.hiddenInput.value = value;

    // Update trigger text
    this.trigger.querySelector('.custom-sort-dropdown__selected').textContent = label;

    // Update active state
    this.options.forEach(opt => {
      opt.classList.remove('active');
      opt.setAttribute('aria-selected', 'false');
    });
    option.classList.add('active');
    option.setAttribute('aria-selected', 'true');

    // Close dropdown
    this.closeDropdown();

    // Trigger change event for facet filters
    this.triggerSortChange(value);
  }

  triggerSortChange(value) {
    const facetForm = this.closest('facet-filters-form');
    if (facetForm && typeof facetForm.onSortChange === 'function') {
      // Create synthetic change event
      const changeEvent = new Event('change', { bubbles: true });
      Object.defineProperty(changeEvent, 'target', {
        writable: false,
        value: this.hiddenInput
      });
      facetForm.onSortChange(changeEvent);
    }
  }
}

// Define the custom element
customElements.define('custom-sort-dropdown', CustomSortDropdown);